import { render } from "./Beratung.vue?vue&type=template&id=3b705cc1&scoped=true"
import script from "./Beratung.vue?vue&type=script&lang=js"
export * from "./Beratung.vue?vue&type=script&lang=js"

import "./Beratung.vue?vue&type=style&index=0&id=3b705cc1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b705cc1"]])

export default __exports__